export default __webpack_public_path__ + "static/cta-back-8b5d2a3dca49ca48b83430e83b09ba7e.webp";